import { render, staticRenderFns } from "./vipDisposition.vue?vue&type=template&id=015199f0&scoped=true"
import script from "./vipDisposition.vue?vue&type=script&lang=ts"
export * from "./vipDisposition.vue?vue&type=script&lang=ts"
import style0 from "./vipDisposition.vue?vue&type=style&index=0&id=015199f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015199f0",
  null
  
)

export default component.exports